// Progress allocation for full scan type
export const FULL_SCAN_STAGES = [
    { type: 'ssl', startPercent: 0, endPercent: 15 },
    { type: 'headers', startPercent: 15, endPercent: 30 },
    { type: 'ports', startPercent: 30, endPercent: 45 },
    { type: 'dast', startPercent: 45, endPercent: 80 },
    { type: 'api-fuzz', startPercent: 80, endPercent: 100 },
];
// Step messages shown to users during scan
export const SCAN_STEP_MESSAGES = {
    ssl: [
        'Connecting to your site securely...',
        'Checking your security certificate...',
        'Verifying encryption strength...',
        'Reviewing certificate chain...',
    ],
    headers: [
        'Loading your site...',
        'Checking security headers...',
        'Reviewing content policies...',
        'Analyzing protection settings...',
    ],
    ports: [
        'Scanning your network...',
        'Checking common ports...',
        'Identifying running services...',
        'Reviewing open connections...',
    ],
    dast: [
        'Starting ZAP security scanner...',
        'Spidering your site to discover pages...',
        'Running passive security analysis...',
        'Actively testing for vulnerabilities...',
        'Collecting and analyzing results...',
    ],
    'api-fuzz': [
        'Searching for API specification...',
        'Discovering API endpoints...',
        'Fuzzing parameters with injection payloads...',
        'Testing authorization controls...',
        'Checking for method tampering vulnerabilities...',
        'Analyzing API security results...',
    ],
    full: [
        'Starting full security assessment...',
        'This will check everything — sit tight!',
    ],
};
export const MAX_CONCURRENT_SCANS_PER_PROJECT = 1;
export const MAX_CONCURRENT_SCANS_PER_USER = 3;
export const SCAN_TIMEOUT_SECONDS = 900; // 15 minutes
//# sourceMappingURL=scan-types.js.map